var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("OrganisationName")))])]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.organisationName))]],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [
                  _c("b", [_vm._v(_vm._s(_vm.$t("Pdf.OrganisationNumber")))])
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.organisationNumber))]],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("AidYear")))])]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.model.record.year))]],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("AidTargetNumber")))])]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.model.record.aidTargetNumber))]],
        2
      ),
      _vm._v(" "),
      !_vm.showScore
        ? _c("div", [
            _c("p", { staticClass: "mt-5" }, [_vm._v(_vm._s(_vm.noScoreText))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showScore
        ? _c("div", [
            _c("h2", { staticClass: "mt-5 mb-2" }, [
              _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Description1")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$t("Feedback.SummaryReport.Description2", {
                    0: _vm.model.record.year
                  })
                )
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Description3")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("Feedback.SummaryReport.SummaryScore")) + " "
              ),
              _c("strong", [
                _vm._v(_vm._s(_vm.$t(_vm.feedbackInfo.performance)))
              ])
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table tablerow mt-4 mb-5" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "w-30" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Valuation")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "w-10" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Feedback.SummaryReport.Performance"))
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Score_1")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t(_vm.feedbackInfo.score_1)))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Score_2")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t(_vm.feedbackInfo.score_2)))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Score_3")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t(_vm.feedbackInfo.score_3)))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Score_4")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t(_vm.feedbackInfo.score_4)))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Score_5")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t(_vm.feedbackInfo.score_5)))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Score_6")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t(_vm.feedbackInfo.score_6)))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Score_7")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t(_vm.feedbackInfo.score_7)))
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("Feedback.SummaryReport.Description4")))
            ]),
            _vm._v(" "),
            _c("br")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }